import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { TodosPage } from './pages/TodosPage';
import { BookmarksPage } from './pages/BookmarksPage';
import { NotesPage } from './pages/NotesPage';
import { CalendarPage } from './pages/CalendarPage';
import { LessonPlansPage } from './pages/LessonPlansPage';
import { SubPlansPage } from './pages/SubPlansPage';
import { ArchivesPage } from './pages/ArchivesPage';
import { SettingsPage } from './pages/SettingsPage';
import { RosterPage } from './pages/RosterPage';
import { SeatingPage } from './pages/SeatingPage';
import { JobsPage } from './pages/JobsPage';
import { PhotosPage } from './pages/PhotosPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { DataPage } from './pages/DataPage';
import { PrivacyProvider } from './privacy/PrivacyContext';
import { ConfirmProvider } from './components/ConfirmDialog';
import { AppearanceProvider } from './theme/Appearance';

function Gate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-stone">Loading…</p>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="lesson-plans" element={<LessonPlansPage />} />
        <Route path="sub-plans" element={<SubPlansPage />} />
        <Route path="todos" element={<TodosPage />} />
        <Route path="roster" element={<RosterPage />} />
        <Route path="seating" element={<SeatingPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="photos" element={<PhotosPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="data" element={<DataPage />} />
        <Route path="notes" element={<NotesPage />} />
        <Route path="bookmarks" element={<BookmarksPage />} />
        <Route path="settings" element={<SettingsPage />} />
        {/* Deliberately not in the sidebar — reached from Settings → School year. */}
        <Route path="archives" element={<ArchivesPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PrivacyProvider>
          <ConfirmProvider>
            <AppearanceProvider />
            <Gate />
          </ConfirmProvider>
        </PrivacyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
